"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const errors_1 = require("../../errors");
const IndustryExpertise_1 = require("../models/OrgProfile/IndustryExpertise");
const ProfileStatus_1 = require("../models/OrgProfile/ProfileStatus");
const WarehouseCapabilities_1 = require("../models/OrgProfile/WarehouseCapabilities");
class OrgProfileFilterValidator {
    orgProfileStatus = Object.values(ProfileStatus_1.ProfileStatus);
    expertises = Object.values(IndustryExpertise_1.IndustryExpertise);
    certifications = Object.values(WarehouseCapabilities_1.WarehouseCertifications);
    capabilities = Object.values(WarehouseCapabilities_1.WarehouseCapabilities);
    _orgProfileFilterSchema = joi_1.default.object({
        status: joi_1.default.array()
            .items(joi_1.default.string().valid(...this.orgProfileStatus))
            .optional(),
        region: joi_1.default.array().items(joi_1.default.string()).optional(),
        expertise: joi_1.default.array()
            .items(joi_1.default.string().valid(...this.expertises))
            .optional(),
        featured: joi_1.default.boolean().optional(),
        defaultRecommendation: joi_1.default.boolean().optional(),
        certifications: joi_1.default.array()
            .items(joi_1.default.string().valid(...this.certifications))
            .optional(),
        capabilities: joi_1.default.array()
            .items(joi_1.default.string().valid(...this.capabilities))
            .optional(),
        warehouseSize: joi_1.default.number().optional(),
        numberOfPallets: joi_1.default.number().optional(),
        includeDefaultPartners: joi_1.default.boolean().optional(),
    });
    validate(orgProfileFilter) {
        const issues = [];
        const result = this._orgProfileFilterSchema.validate(orgProfileFilter, {
            abortEarly: false,
            convert: false,
        });
        if (result.error) {
            result.error.details.forEach((issue) => {
                switch (issue.type) {
                    case 'any.required': {
                        issues.push(new errors_1.Errors.ValidationIssue('IOrgProfileFilter', errors_1.Errors.ValidationErrorCode.requiredValue, issue.context?.key, undefined));
                        break;
                    }
                    case 'array.unique': {
                        issues.push(new errors_1.Errors.ValidationIssue('IOrgProfileFilter', errors_1.Errors.ValidationErrorCode.notAllowed, issue.context?.label, issue.context?.value));
                        break;
                    }
                    case 'object.unknown': {
                        issues.push(new errors_1.Errors.ValidationIssue('IOrgProfileFilter', errors_1.Errors.ValidationErrorCode.notAllowed, issue.context?.key, issue.context?.value));
                        break;
                    }
                    case 'object.base': {
                        issues.push(new errors_1.Errors.ValidationIssue('IOrgProfileFilter', errors_1.Errors.ValidationErrorCode.invalidType, undefined, issue.context?.value));
                        break;
                    }
                    case 'string.base':
                    case 'array.base':
                    case 'number.base': {
                        issues.push(new errors_1.Errors.ValidationIssue('IOrgProfileFilter', errors_1.Errors.ValidationErrorCode.invalidType, issue.context?.label ||
                            issue.context?.key, issue.context?.value));
                        break;
                    }
                    case 'number.min':
                    case 'string.max':
                    case 'string.min':
                    case 'string.trim':
                    case 'string.empty':
                    case 'string.pattern.base':
                    case 'number.integer': {
                        issues.push(new errors_1.Errors.ValidationIssue('IOrgProfileFilter', errors_1.Errors.ValidationErrorCode.invalidValue, issue.context?.key, issue.context?.value));
                        break;
                    }
                }
            });
        }
        if (issues.length > 0) {
            const validationError = new errors_1.Errors.ValidationError();
            validationError.validationIssues = issues;
            throw validationError;
        }
    }
}
exports.default = OrgProfileFilterValidator;
